import { render, staticRenderFns } from "./ZenithInstructions.vue?vue&type=template&id=8ff2a1fa&"
import script from "./ZenithInstructions.vue?vue&type=script&lang=js&"
export * from "./ZenithInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports